export const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../pages/index'),
    meta: { isAuth: false, resource: 'index' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/login'),
    meta: { isAuth: false, resource: 'auth' },
  },
  {
    path: '/reset',
    name: 'reset',
    component: () => import('../pages/resetPassword/ResetPassword.vue'),
    meta: { isAuth: false, resource: 'auth' },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../pages/Logout.vue'),
    meta: { isAuth: true, resource: 'auth' },
  },
  {
    path: '/logs',
    name: 'logs',
    component: () => import('../pages/logs/Logs.vue'),
    meta: { isAuth: true, resource: 'logs' },
  },
  {
    path: '/logs/:id',
    name: 'log',
    component: () => import('../pages/log/Log.vue'),
    meta: { isAuth: true, resource: 'logs' },
  },
  {
    path: '/applications',
    name: 'applications',
    component: () => import('../pages/applications/Applications.vue'),
    meta: { isAuth: true, resource: 'applications' },
  },
  {
    path: '/applications/:id',
    name: 'application',
    component: () => import('../pages/application/Application.vue'),
    meta: { isAuth: true, resource: 'applications' },
  },
  {
    path: '/managers',
    name: 'managers',
    component: () => import('../pages/managers/Managers.vue'),
    meta: { isAuth: true, resource: 'managers' },
  },
  {
    path: '/managers/create',
    name: 'manager-create',
    component: () => import('../pages/managerCreate/ManagerCreate.vue'),
    meta: { isAuth: true, resource: 'managers' },
  },
  {
    path: '/managers/:id',
    name: 'manager-edit',
    component: () => import('../pages/managerEdit/ManagerEdit.vue'),
    meta: { isAuth: true, resource: 'managers' },
  },
  {
    path: '/payments',
    name: 'payments',
    component: () => import('../pages/payments/Payments.vue'),
    meta: { isAuth: true, resource: 'payments' },
  },
  {
    path: '/payments-timeline',
    name: 'payments-timeline',
    component: () => import('../pages/paymentsTimeline/PaymentsTimeline.vue'),
    meta: { isAuth: true, resource: 'payments' },
  },
  {
    path: '/finances',
    name: 'finances',
    component: () => import('../pages/finances/Finances.vue'),
    meta: { isAuth: true, resource: 'finances' },
  },
  {
    path: '/finances-detail',
    name: 'finances-detail',
    component: () => import('../pages/financesDetail.vue'),
    meta: { isAuth: true, resource: 'finances' },
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('../pages/account/Account.vue'),
    meta: { isAuth: true, resource: 'account' },
  },
  {
    path: '*',
    component: () => import('../pages/NotFound.vue'),
    meta: { isAuth: true, resource: '404' },
  },
]
